module.exports = __webpack_public_path__ + "8e67b8bb7719f625013c474d73954218.png";